// extracted by mini-css-extract-plugin
export default {"text":"aGeUdwR6zZoJ5H52j6dNIA==","sizeLimit":"PRDR4GWnQdIoGfXhz5SZsw=="};